import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "@filadd/phi-plus-core";
const INSTALLMENT_STATUS = {
    SOON_DUE: "soonDue",
    OVERDUE: "overdue",
};
const STATUS_ICON = {
    [INSTALLMENT_STATUS.SOON_DUE]: "warning",
    [INSTALLMENT_STATUS.OVERDUE]: "error",
};
const IconTypes = {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info",
    WARNING: "warning",
};
export const CheckoutInstallmentStatusBanner = ({ status, description, }) => {
    const type = STATUS_ICON[status];
    return (_jsx(Alert, { type: IconTypes[type.toUpperCase()], children: description }));
};
//# sourceMappingURL=CheckoutInstallmentStatusBanner.js.map